

export const EMAIL_PATTERN = String.raw`^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$`;
export const NUMBERS_PATTERN = String.raw`^-?[0-9]+$`;
export const DOUBLE_PATTERN = '[+-]?([0-9]*[.])?[0-9]+';

export const PHONE_NUMBER_PATTERN =  String.raw`^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$`;
export const URL_PATTERN = String.raw`(https?:\/\/)?([\w\-])+\.{1}([a-zA-Z0-9]{2,63})([\/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)`;

export const DATE_DISPLAY_FORMAT = "EEE dd MMM yyyy h:mm a";